import React, { useState, useEffect } from "react";
import EducationMenu from "../Education/EducationMenu/EducationMenu";

import PositionMenu from "../Experience/PositionMenu/PositionMenu";
import useExperience from "../../../hooks/useExperience";
import useEducation from "../../../hooks/useEducation";
import { getUserName } from "../../../hooks";

const CareerMenu = ({ setShowCareerMenu }) => {
  const [showPositionMenu, setShowPositionMenu] = useState(false);
  const [showEducationMenu, setShowEducationMenu] = useState(false);
  const [educationField, setEducationField] = useState('Loading...');
  const [positionField, setPositionField] = useState('Loading...');
  const [positionData, setPositionData] = useState({

    company_id: 0,
    title: "",
    employment_type: "Full Time",
    location: "",
    start_date: "",
    end_date: "",
    is_current: false,
    description: "",
    start_year: "",
    end_year: ""
  });
  const [educationData, setEducationData] = useState({

    degree: '',
    field_of_study: 'Computer Science',
    institution_id: 0,
    location: '',
    start_date: '',
    end_date: '',
    is_current: false,
    grade: '',
    activities: '',
    description: '',
    start_year: '',
    end_year: '',
  });

  const resetEducationData = () => {
    setEducationData({
      degree: '',
      field_of_study: 'Computer Science',
      institution_id: 0,
      location: '',
      start_date: '',
      end_date: '',
      is_current: false,  
      grade: '',
      activities: '',
      description: '',
      start_year: '',
      end_year: '',
    });
  }




  const resetPositionData = () => {
    setPositionData({
      company_id: 0,
      title: "",
      employment_type: "Full Time",
      location: "",
      start_date: "",
      end_date: "",
      is_current: false,
      description: "",
      start_year: "",
      end_year: ""
    });
  }
  const { experience, experienceDataLoaded } = useExperience(getUserName());
  const { education, educationDataLoaded } = useEducation(getUserName());

  useEffect(() => {
    if (educationDataLoaded) {
      if (education.length > 0) {
        const firstEducation = education[0];
        setEducationField(firstEducation?.institution?.name || '');
      } else {
        setEducationField('Add Education');
      }
    } else {
      setEducationField('Loading...');
    }
  }, [educationDataLoaded, education]);

  useEffect(() => {
    if (experienceDataLoaded) {
      if (experience.length > 0) {
        setPositionField(experience[0]?.title || '');
      } else {
        setPositionField('Add Position');
      }
    } else {
      setPositionField('Loading...');
    }
  }, [experienceDataLoaded, experience]);



  const handleAddPositionClick = () => {
    setShowPositionMenu(true);
  };

  const handleAddEducationClick = () => {
    setShowEducationMenu(true);
  };


  const handleSuccess = () => {
    resetPositionData();
    resetEducationData();
    setShowCareerMenu(false);
  };

  return (
    <div className="popup_div active">
      <div className="popup_cont sk">
        {showPositionMenu ? (
          <PositionMenu setShowPositionMenu={setShowPositionMenu} handleSuccess={handleSuccess} menuTitle={"Add Position"} positionData={positionData} setPositionData={setPositionData} />
        ) : showEducationMenu ? (
          <EducationMenu setShowEducationMenu={setShowEducationMenu} handleSuccess={handleSuccess} menuTitle={"Add Education"} educationData={educationData} setEducationData={setEducationData} />
        ) : (
          <div data-name="followers" className="edit_profile_pop hidden active">
            <div className="div-block-520">
              <div className="text-block-386">Edit Profile Information</div>
              <div className="cancel_edit_profile w-embed" onClick={() => setShowCareerMenu(false)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  fill="var(--accent)"
                  height="16px"
                  width="16px"
                  version="1.1"
                  id="Capa_1"
                  viewBox="0 0 460.775 460.775"
                  xmlSpace="preserve"
                >
                  <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z" />
                </svg>
              </div>
            </div>
            <div className="div-block-525">
              <div className="div-block-469 sk_s form_div">
                <div className="form_row">
                  <div className="text-block-297">Current Position</div>
                  <div className="form-block-15 s_skill w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      className="form-10"
                      data-wf-page-id="6596f9cde7a06c303cf07fbf"
                      data-wf-element-id="316eeb69-6abf-e4b7-a02e-d4803b385246"
                      aria-label="Email Form"
                    >
                      <div className="select-field-3 w-select">{positionField}</div>

                    </form>
                    <a
                      data-w-id="316eeb69-6abf-e4b7-a02e-d4803b38524e"
                      href="#"
                      className="link-block-35 w-inline-block"
                      onClick={handleAddPositionClick}
                    >
                      <img
                        src="https://cdn.prod.website-files.com/6596e21ac435cac3c66baad8/66f2b9df760bcd7636eacf9a_plus.svg"
                        loading="lazy"
                        alt=""
                        className="image-234"
                      />
                      <h5 className="heading-13">Add new position</h5>
                    </a>
                  </div>
                </div>
                <div className="form_row">
                  <div className="text-block-297">Education</div>
                  <div className="form-block-15 s_skill w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      className="form-10"
                      data-wf-page-id="6596f9cde7a06c303cf07fbf"
                      data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb837175"
                      aria-label="Email Form"
                    >
                      <div className="select-field-3 w-select">{educationField}</div>

                    </form>
                    <a
                      data-w-id="5af42790-1195-9f34-4148-2e396f845ef4"
                      href="#"
                      className="link-block-35 w-inline-block"
                      onClick={handleAddEducationClick}
                    >
                      <img
                        src="https://cdn.prod.website-files.com/6596e21ac435cac3c66baad8/66f2b9df760bcd7636eacf9a_plus.svg"
                        loading="lazy"
                        alt=""
                        className="image-234"
                      />
                      <h5 className="heading-13">Add new education</h5>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="popup-f add_content">
              <div className="div-block-475 cancel_edit_prof" onClick={() => setShowCareerMenu(false)}>
                <div className="text-block-284 cancel_dc">Cancel</div>
              </div>
              <div className="div-block-475 save_profile_info">
                <div className="text-block-284 add_skill_text">Save</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CareerMenu;
